<template>
  <div>
    <div v-if="!unsubscribing">
      <b-container v-if="error">
        <b-row>
          <b-col md="9" lg="7" class="mx-auto">
            <b-col cols="12" class="mx-auto">
              <h2 class="mb-3"><translate>Shipping</translate> <strong v-translate>NOT FOUND</strong></h2>

              <h4 class="mb-3" v-translate>Sorry, the shipping you are trying to access doesn't exists!</h4>
              <p v-translate>If you've copied and pasted the link make sure it is complete. Please try again.</p>
            </b-col>
          </b-col>
        </b-row>
      </b-container>
      <b-container v-if="form">
        <b-row>
          <b-col md="9" lg="7" class="mx-auto">
            <b-col cols="12" class="mx-auto">
              <h2 class="mb-3"><translate>Shipping Information</translate></h2>
              <b-card>
                <h4 class="mb-3" v-translate>Please enter the Shipping ID below to see all your shipping information in real time.</h4>
                <b-form action="" method="GET">
                  <b-row>
                    <b-col>
                      <label for="shipping-id" v-translate>Shipping ID</label>
                      <b-input type="text" name="id" id="shipping-id" class="mb-3" required />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-button type="submit" variant="primary" v-translate>Search</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card>
            </b-col>
          </b-col>
        </b-row>
      </b-container>
      <!-- is NOT reverse flow -->
      <div v-if="shipping.id && !isReverse">
        <!-- READY || DRAFT -->
        <b-container v-if="!isCloseToArrive && !error && !form && $route.query.hash"
          :class="shipping.status ? shipping.status.toLowerCase() : ''">
          <b-row>
            <b-col>
              <h2 class="mb-3"><translate>Shipping</translate> <strong>#{{shipping.id | uuid}}</strong></h2>
              <shipping-statuses :shipping="shipping" />
              <div v-show="visits < 0 && shipping.status === 'DRAFT'">
                <h4 class="mb-3" v-translate="{contact: shipping.to_contact || '', company: shipping.company ? shipping.company.name : shipping.from_contact || ''}">Hi! We will receive something from %{company} soon to deliver it to you!</h4>
                <div v-show="shipping.address_to && (!shipping.fields_revision_data || !shipping.fields_revision_data.to)">
                  <h5 class="mb-3" v-show="shipping.status === 'DRAFT'" v-translate>You will be able to track your shipping in real time once we have received your package and are on the way.</h5>
                  <h5 class="mb-3" v-show="(isScheduled && shipping.status === 'CONFIRMED') || shipping.status === 'READY'" v-translate>You will be able to track your shipping in real time once we are on the way.</h5>
                  <h5 class="mb-3" v-translate="{courierI18n: this.courierI18n}">Please be aware that the %{courierI18n} may have to do other deliveries before yours.</h5>
                </div>
                <p v-translate>Please, review the destination address just to be sure we will reach you without any kind of incidence 😊</p>
              </div>
              <div v-show="visits < 0 && shipping.status === 'READY'">
                <h4 class="mb-3" v-translate="{contact: shipping.to_contact || '', company: shipping.company ? shipping.company.name : shipping.from_contact || ''}">Hi! We have something for you sent by %{company}!</h4>
                <div v-show="shipping.address_to && (!shipping.fields_revision_data || !shipping.fields_revision_data.to)">
                  <h5 class="mb-3" v-show="shipping.status === 'DRAFT'" v-translate>You will be able to track your shipping in real time once we have received your package and are on the way.</h5>
                  <h5 class="mb-3" v-show="(isScheduled && shipping.status === 'CONFIRMED') || shipping.status === 'READY'" v-translate>You will be able to track your shipping in real time once we are on the way.</h5>
                  <h5 class="mb-3" v-translate="{courierI18n: this.courierI18n}">Please be aware that the %{courierI18n} may have to do other deliveries before yours.</h5>
                </div>
                <p v-translate>Please, review the destination address just to be sure we will reach you without any kind of incidence 😊</p>
              </div>
              <div v-show="visits > 0">
                <h4 class="mb-3" v-translate="{contact: shipping.to_contact || '', company: shipping.company ? shipping.company.name : shipping.from_contact || ''}">Hi! We have tried to deliver something for you sent by %{company}!</h4>
                <div v-show="shipping.address_to && (!shipping.fields_revision_data || !shipping.fields_revision_data.to)">
                  <h5 class="mb-3" v-show="shipping.status === 'DRAFT'" v-translate>You will be able to track your shipping in real time once we have received your package and are on the way.</h5>
                  <h5 class="mb-3" v-show="(isScheduled && shipping.status === 'CONFIRMED') || shipping.status === 'READY'" v-translate>You will be able to track your shipping in real time once we are on the way.</h5>
                  <h5 class="mb-3" v-translate="{courierI18n: this.courierI18n}">Please be aware that the %{courierI18n} may have to do other deliveries before yours.</h5>
                </div>
                <p v-translate>You still can review the destination address just to be sure we will reach you without any kind of incidence 😊</p>
              </div>
              <p class="mb-4" v-translate>Here's the address information we have:</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="7" class="mx-auto">
              <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged">
                <h5 class="m-0" v-translate>Destination address was updated!</h5>
              </b-alert>
              <b-card>
                <b-col cols="12" class="shipping-destination">
                  <h5 class="shipping-contact mb-3 pt-1" v-translate>Destination Data</h5>
                  <shipping-checkpoint v-if="shipping.id" :shipping="shipping" with-edit with-instructions with-icons big-edit-button @updated="checkTracking" />
                </b-col>
              </b-card>
            </b-col>
            <b-col>
              <b-card class="shipping-statuses">
                <shipping-status-history :shipping="shipping" faked v-if="shipping.shipping_type" />
              </b-card>
            </b-col>
          </b-row>
        </b-container>

        <!-- /READY || DRAFT -->

        <!-- CONFIRMED && still scheduled -->
        <b-container v-if="!error && !form && !isCloseToArrive && !$route.query.hash && (shipping.status !== 'DELIVERED' && shipping.status !== 'CANCELED')"
          :class="shipping.status ? shipping.status.toLowerCase() : ''">
          <b-row>
            <b-col md="8" lg="6" class="mx-auto">
              <h2 class="mb-3"><translate>Shipping</translate> <strong>#{{shipping.id | uuid}}</strong></h2>
              <p class="status"><translate>Current Status:</translate> <strong><shipping-statuses :shipping="shipping" text-only /></strong></p>
              <h4 class="mb-3" v-translate="{contact: shipping.to_contact || '', company: shipping.company ? shipping.company.name : shipping.from_contact || ''}" v-if="shipping.status === 'DRAFT'">Hi! We will receive something from %{company} soon to deliver it to you!</h4>
              <h4 class="mb-3" v-translate="{contact: shipping.to_contact || '', company: shipping.company ? shipping.company.name : shipping.from_contact || ''}" v-else>Hi! We have something for you sent by %{company}!</h4>
              <h5 class="mb-3" v-show="shipping.status === 'DRAFT'" v-translate>You will be able to track your shipping in real time once we have received your package and are on the way.</h5>
              <h5 class="mb-3" v-show="shipping.status === 'CONFIRMED' || shipping.status === 'WAITING' || shipping.status === 'READY' || shipping.status === 'ATPICKUPPOINT' || shipping.status === 'PICKEDUP' || shipping.status === 'INTRANSIT'" v-translate>You will be able to track your shipping in real time once we are on the way directly to you.</h5>
              <h5 class="mb-3" v-translate="{courierI18n: this.courierI18n}">Please be aware that the %{courierI18n} may have to do other deliveries before yours.</h5>

              <shipping-eta-box :shipping="shipping" v-if="shipping.address_to && ['AR', 'UY'].indexOf(shipping.address_to.country) !== -1" />

              <b-card class="shipping-statuses">

                <shipping-status-history :shipping="shipping" faked v-if="shipping.shipping_type" />

              </b-card>
            </b-col>
          </b-row>
        </b-container>
        <!-- ONGOING -->
        <b-row v-if="isCloseToArrive">
          <b-col id="shipping-form" cols="12" class="order-2 order-lg-1">
            <b-card class="shipping-item" :class="shipping.status ? shipping.status.toLowerCase() : ''">
              <b-row>
                <b-col cols="6" style="padding-left:35px">
                  <strong style="font-size: 18px">#{{shipping.id | uuid}}</strong>
                </b-col>
                <b-col cols="6" class="text-right">
                  {{moment.utc(shipping.created_at).tz($tz).format('L LT')}}
                </b-col>
                <b-col cols="12" style="padding-left:35px">
                  <h5 class="mt-3 text-info" v-translate="{courierI18n: this.courierI18n}">Please be aware that the %{courierI18n} may have to do other deliveries before yours.</h5>
                </b-col>
                <b-col cols="12" class="shipping-status" style="margin-top:20px; margin-bottom: 20px;">

                  <shipping-statuses :shipping="shipping" />

                </b-col>
                <b-col cols="12" class="shipping-origin mb-3">
                  <h5 class="shipping-contact">{{shipping.company ? shipping.company.name : shipping.from_contact}}</h5>
                </b-col>
                <b-col cols="12" class="shipping-destination">
                  <shipping-checkpoint v-if="shipping.id" :shipping="shipping" with-edit with-instructions with-icons big-edit-button @updated="checkTracking" />
                </b-col>
                <b-col cols="12" class="shipping-actions text-right">

                </b-col>
              </b-row>
            </b-card>
            <b-card v-if="shipping.courier !== null">
              <b-row>
                <b-col cols="12">
                  <b-row>
                    <b-col cols="3">
                      <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" class="rounded-circle profile-image" alt="img" :style="'width: 100%; height: auto; background-image: url(' + (shipping.courier.profile_picture || 'https://www.gravatar.com/avatar/default?s=100&r=pg&d=mm') + ')'" />
                    </b-col>
                    <b-col cols="5" class="align-self-center">
                      <h5>{{shipping.courier.name}}</h5>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card>
            <b-card class="shipping-statuses">

              <shipping-status-history :shipping="shipping" faked v-if="shipping.shipping_type" />

            </b-card>
          </b-col>
          <b-col class="order-1 order-lg-2" id="shipping-map">
            <leaflet-map ref="fullMap" style="height: 100%" :zoom="17" :geolocate="false" fit-once />
          </b-col>
        </b-row>
        <!-- /ONGOING -->
        <!-- DELIVERED || scheduled -->
        <b-row v-if="!error && !isCloseToArrive && shipping.status !== null && (shipping.status === 'DELIVERED' || shipping.status === 'CANCELED' || ( shipping.status === 'WAITING' && isScheduled))">
          <b-container>
            <b-row>
              <b-col lg="6">
                <b-card class="shipping-item" :class="shipping.status ? shipping.status.toLowerCase() : ''">
                  <b-row>
                    <b-col cols="12" class="shipping-status" style="margin-bottom: 10px;">

                      <shipping-statuses :shipping="shipping" v-if="shipping.shipping_type" />

                    </b-col>
                    <b-col cols="6" style="padding-left:35px">
                      <strong>#{{shipping.id | uuid}}</strong>
                    </b-col>
                    <b-col cols="6" class="text-right" v-show="totalTime && this.shipping.status !== 'CANCELED'">
                      <strong><font-awesome-icon :icon="['far', 'clock']" size="1x" /> {{totalTime}}</strong>
                    </b-col>
                    <b-col cols="12" v-if="markers.length !== 0">
                      <mapbox-static-map :google-api-key="this.$appConfig.maps.api_key" :format="format" :markers="markers" :zoom="-1" :center="center" :size="size" :type="type" :language="language" class="card-img-top d-noneX d-lg-blockX" :customStyle="this.$appConfig.maps.staticMapStyle" style="margin: 20px 0" v-if="shipping.status !== null && (shipping.status === 'DELIVERED' || shipping.status === 'CANCELED' || ( shipping.status === 'WAITING' && isScheduled))"></mapbox-static-map>
                    </b-col>
                  </b-row>
                </b-card>
                <b-card v-if="shipping.courier?.id">
                  <b-row>
                    <b-col cols="12">
                      <b-row>
                        <b-col cols="3">
                          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" class="rounded-circle profile-image" alt="img" :style="'width: 100%; height: auto; background-image: url(' + (shipping.courier.profile_picture || 'https://www.gravatar.com/avatar/default?s=100&r=pg&d=mm') + ')'" />
                        </b-col>
                        <b-col cols="5" class="align-self-center">
                          <h5>{{shipping.courier.name}}</h5>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
              <b-col lg="6">
                <b-card class="shipping-item" :class="shipping.status ? shipping.status.toLowerCase() : ''">
                  <b-col cols="12" class="shipping-origin">
                    <h5 class="shipping-contact" style="font-size:18px;line-height:1.4">{{shipping.company ? shipping.company.name : shipping.from_contact}}</h5>
                    <h5 class="text-secondary" v-translate="{pickedupAt: moment.utc(pickedupAt).tz($tz).format('L LT')}" v-show="!isScheduled && this.shipping.status !== 'CANCELED'">Picked Up: %{pickedupAt}</h5>
                  </b-col>
                  <b-col cols="12" class="shipping-destination">
                    <!-- <h5 class="shipping-contact" style="font-size: 18px;line-height:1.4">{{shipping.to_contact}}</h5> -->
                    <h5 class="text-primary" style="line-height: 1.5;" v-translate="{deliveredAt: moment.utc(deliveredAt).tz($tz).format('L LT')}" v-show="!isScheduled && this.shipping.status !== 'CANCELED'">Delivered: %{deliveredAt}</h5>
                    <!-- <p><span class="shipping-address">{{shipping.address_to ? shipping.address_to.formatted_address : ''}}</span></p> -->
                  </b-col>
                </b-card>
              </b-col>
            </b-row>
          </b-container>
        </b-row>
      </div>
      <!-- /is NOT reverse flow -->
      <!-- is reverse flow -->
      <div v-if="shipping.id && isReverse">

        <!-- READY || DRAFT -->
        <b-container v-if="!isCloseToArrive && !error && !form && $route.query.hash"
          :class="shipping.status ? shipping.status.toLowerCase() : ''">
          <b-row>
            <b-col>
              <h2 class="mb-3"><translate>Shipping</translate> <strong>#{{shipping.id | uuid}}</strong></h2>
              <p class="status"><translate>Current Status:</translate> <strong><shipping-statuses :shipping="shipping" text-only /></strong></p>
              <div v-show="visits <= 0">
                <h4 class="mb-3" v-translate="{contact: shipping.from_contact || '', company: shipping.company ? shipping.company.name : shipping.to_contact || ''}" v-if="shipping.status === 'DRAFT' || shipping.status === 'READY' || shipping.status === 'CONFIRMED'">Hi! We will go to your home to get your return for %{company} soon!</h4>
                <h4 class="mb-3" v-translate="{contact: shipping.from_contact || '', company: shipping.company ? shipping.company.name : shipping.to_contact || ''}" v-else>Hi! We have your return for %{company}!</h4>
              </div>
              <div v-show="visits > 0">
                <h4 class="mb-3" v-translate="{contact: shipping.from_contact || '', company: shipping.company ? shipping.company.name : shipping.to_contact || ''}">Hi! We have tried to pickup your return for %{company}!</h4>
              </div>
              <h5 class="mb-3" v-show="shipping.status === 'DRAFT' || shipping.status === 'READY' || shipping.status === 'WAITING' || shipping.status === 'CONFIRMED'" v-translate="{courierI18n: this.courierI18n}">You will be able to track our %{courierI18n} in real time as soon as your return shipping is assigned and we are on the way directly to you.</h5>
              <h5 class="mb-3" v-translate="{courierI18n: this.courierI18n}">Please be aware that the %{courierI18n} may have to do other stops before yours.</h5>
              <p v-show="visits <= 0" v-translate>Please, review your address just to be sure we will reach you without any kind of incidence 😊</p>
              <p v-show="visits > 0" class="mb-4" v-translate>Here's the address information we have:</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="7" class="mx-auto">
              <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged">
                <h5 class="m-0" v-translate>Destination address was updated!</h5>
              </b-alert>
              <b-card>
                <b-col cols="12" class="shipping-destination">
                  <h5 class="shipping-contact mb-3 pt-1" v-translate>Origin Data</h5>
                  <shipping-checkpoint v-if="shipping.id" checkpoint="from" :shipping="shipping" with-edit with-instructions with-icons big-edit-button @updated="checkTracking" />
                </b-col>
              </b-card>
            </b-col>
            <b-col>
              <b-card class="shipping-statuses">
                <shipping-status-history :shipping="shipping" faked v-if="shipping.shipping_type" />
              </b-card>
            </b-col>
          </b-row>
        </b-container>

        <!-- /READY || DRAFT -->

        <!-- Before going to pickup && !isCloseToArrive -->
        <b-container v-if="!error && !form && !isCloseToArrive && !$route.query.hash && (shipping.status !== 'DELIVERED' && shipping.status !== 'CANCELED')"
          :class="shipping.status ? shipping.status.toLowerCase() : ''">
          <b-row>
            <b-col md="8" lg="6" class="mx-auto">
              <h2 class="mb-3"><translate>Shipping</translate> <strong>#{{shipping.id | uuid}}</strong></h2>
              <p class="status"><translate>Current Status:</translate> <strong><shipping-statuses :shipping="shipping" text-only /></strong></p>
              <h4 class="mb-3" v-translate="{contact: shipping.from_contact || '', company: shipping.company ? shipping.company.name : shipping.to_contact || ''}" v-if="shipping.status === 'DRAFT' || shipping.status === 'CONFIRMED'">Hi! We will go to your home to get your return for %{company} soon!</h4>
              <h4 class="mb-3" v-translate="{contact: shipping.from_contact || '', company: shipping.company ? shipping.company.name : shipping.to_contact || ''}" v-else>Hi! We have your return for %{company}!</h4>
              <h5 class="mb-3" v-show="shipping.status === 'DRAFT' || shipping.status === 'READY' || shipping.status === 'WAITING' || shipping.status === 'CONFIRMED'" v-translate="{courierI18n: this.courierI18n}">You will be able to track our %{courierI18n} in real time as soon as your return shipping is assigned and we are on the way directly to you.</h5>
              <h5 class="mb-3" v-translate="{courierI18n: this.courierI18n}">Please be aware that the %{courierI18n} may have to do other stops before yours.</h5>

              <b-card class="shipping-statuses">

                <shipping-status-history :shipping="shipping" faked v-if="shipping.shipping_type" />

              </b-card>
            </b-col>
          </b-row>
        </b-container>

        <!-- isCloseToArrive -->
        <b-row v-if="isCloseToArrive && (shipping.status === 'CONFIRMED' || shipping.status === 'ATPICKUPPOINT')">
          <b-col id="shipping-form" cols="12" class="order-2 order-lg-1">
            <b-card class="shipping-item" :class="shipping.status ? shipping.status.toLowerCase() : ''">
              <b-row>
                <b-col cols="6" style="padding-left:35px">
                  <strong style="font-size: 18px">#{{shipping.id | uuid}}</strong>
                </b-col>
                <b-col cols="6" class="text-right">
                  {{moment.utc(shipping.created_at).tz($tz).format('L LT')}}
                </b-col>
                <b-col cols="12" style="padding-left:35px" v-if="shipping.status !== 'ATPICKUPPOINT'">
                  <h5 class="mt-3 text-info" v-translate="{courierI18n: this.courierI18n}">Please be aware that the %{courierI18n} may have to do other stops before yours.</h5>
                </b-col>
                <b-col cols="12" class="shipping-status" style="margin-top:20px; margin-bottom: 20px;">

                  <shipping-statuses :shipping="shipping" />

                </b-col>
                <b-col cols="12" class="shipping-origin">
                  <shipping-checkpoint v-if="shipping.id" :shipping="shipping" checkpoint="from" with-instructions with-icons big-edit-button @updated="checkTracking" />
                </b-col>
                <b-col cols="12" class="shipping-actions text-right">

                </b-col>
              </b-row>
            </b-card>
            <b-card v-if="shipping.courier !== null">
              <b-row>
                <b-col cols="12">
                  <b-row>
                    <b-col cols="3">
                      <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" class="rounded-circle profile-image" alt="img" :style="'width: 100%; height: auto; background-image: url(' + (shipping.courier.profile_picture || 'https://www.gravatar.com/avatar/default?s=100&r=pg&d=mm') + ')'" />
                    </b-col>
                    <b-col cols="5" class="align-self-center">
                      <h5>{{shipping.courier.name}}</h5>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card>
            <b-card class="shipping-statuses">

              <shipping-status-history :shipping="shipping" faked v-if="shipping.shipping_type" />

            </b-card>
          </b-col>
          <b-col class="order-1 order-lg-2" id="shipping-map">
            <leaflet-map ref="fullMap" style="height: 100%" :zoom="17" :geolocate="false" fit-once v-if="isReverse && shipping.address_from" />
          </b-col>
        </b-row><!-- /isCloseToArrive -->

        <!-- After pickup && before delivery -->
        <b-container v-if="!error && !form && isCloseToArrive && !$route.query.hash && (shipping.status === 'READY' || shipping.status === 'PICKEDUP' || shipping.status === 'INTRANSIT' || shipping.status === 'INCIDENCE')"
          :class="shipping.status ? shipping.status.toLowerCase() : ''">
          <b-row>
            <b-col md="8" lg="6" class="mx-auto">
              <h2 class="mb-3"><translate>Shipping</translate> <strong>#{{shipping.id | uuid}}</strong></h2>
              <p class="status"><translate>Current Status:</translate> <strong><shipping-statuses :shipping="shipping" text-only /></strong></p>
              <h4 class="mb-3" v-translate="{contact: shipping.from_contact || '', company: shipping.company ? shipping.company.name : shipping.to_contact || ''}">Hi! We already have your return for %{company}!</h4>
              <h5 class="mb-3" v-show="shipping.status !== 'INCIDENCE'" v-translate>We are on the go to deliver your return. You may want to forget about it from now 😊</h5>
              <h5 class="mb-3" v-show="shipping.status === 'INCIDENCE'" v-translate>There was an incidence while in transit but we still are on the go to deliver your return. Don't be afraid 😊</h5>

              <b-card class="shipping-statuses">

                <shipping-status-history :shipping="shipping" faked v-if="shipping.shipping_type" />

              </b-card>
            </b-col>
          </b-row>
        </b-container>

        <!-- After delivery -->
        <b-container v-if="!error && !form && isCloseToArrive && shipping.status === 'DELIVERED'"
          :class="shipping.status ? shipping.status.toLowerCase() : ''">
          <b-row>
            <b-col md="8" lg="6" class="mx-auto">
              <h2 class="mb-3"><translate>Shipping</translate> <strong>#{{shipping.id | uuid}}</strong></h2>
              <p class="status"><translate>Current Status:</translate> <strong><shipping-statuses :shipping="shipping" text-only /></strong></p>
              <h4 class="mb-3" v-translate="{contact: shipping.from_contact || '', company: shipping.company ? shipping.company.name : shipping.to_contact || ''}">Hi! Your return for %{company} has been delivered!</h4>
              <h5 class="mb-3" v-show="shipping.status !== 'INCIDENCE'" v-translate="{deliveredAt: moment.utc(deliveredAt).tz($tz).format('L LT')}">Everything went well and your return shipping has arrived our warehouse on %{deliveredAt} 😊</h5>

              <b-card class="shipping-statuses">

                <shipping-status-history :shipping="shipping" faked v-if="shipping.shipping_type" />

              </b-card>
            </b-col>
          </b-row>
        </b-container>
      </div><!-- /is reverse flow -->
    </div>
    <div v-else><!-- Opting-out for notifications-->
      <b-container
        :class="shipping.status ? shipping.status.toLowerCase() : ''">
        <b-row>
          <b-col md="8" lg="6" class="mx-auto">
            <h2 class="mb-3"><translate>Shipping</translate> <strong>#{{shipping.id | uuid}}</strong></h2>
            <p class="status"><translate>Current Status:</translate> <strong><shipping-statuses :shipping="shipping" text-only /></strong></p>
            <h4 class="mb-3" v-translate="{contact: shipping.to_contact || '', company: shipping.company ? shipping.company.name : shipping.from_contact || ''}" v-if="shipping.status === 'DRAFT'">Hi! We will receive something from %{company} soon to deliver it to you!</h4>
            <h4 class="mb-5" v-translate="{contact: shipping.to_contact || '', company: shipping.company ? shipping.company.name : shipping.from_contact || ''}" v-else>Hi! We have something for you sent by %{company}!</h4>
            <h2 class="mb-3 text-info" v-if="!unsubscribed"><b-spinner /> <span v-translate>Opting-out from this shipping notifications, please wait.</span></h2>
            <div v-else>
              <h2 class="mb-3 text-success" v-translate>Opt-out done 👍</h2>
              <h5 class="mb-3" v-translate>You've opted-out for this shipping's notifications and you won't receive any further email about it.</h5>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>
<script>
import AddressMixins from '@/mixins/address.mixin.js'
import { mapGetters } from 'vuex'
import LeafletMap from '@/components/LeafletMap'
import MapboxStaticMap from '@/components/MapboxStaticMap'
import AddressAutocomplete from '@/components/AddressAutocomplete'
import ShippingStatuses from '@/components/ShippingStatuses'
import ShippingStatusHistory from '@/components/ShippingStatusHistory'
import { SHIPPING_RESET_STATE, FETCH_SHIPPING_GUEST } from '@/store/actions.type'
import PlacePicker from '@/components/PlacePicker'
import FixAddressesForm from '@/components/FixAddressesForm'
import ShippingCheckpoint from '@/components/ShippingCheckpoint'
import ShippingEtaBox from '@/components/ShippingEtaBox'
import { loadMoovaChat } from '@/common/moovaChat'

export default {
  name: 'ShippingPage',
  title() {
    const id = this.$route.params.id || this.$route.query.id ? ' #' + this.$options.filters.uuid(this.$route.params.id || this.$route.query.id) : ''
    return this.$gettext('Shipping') + id
  },
  components: {
    MapboxStaticMap,
    LeafletMap,
    AddressAutocomplete,
    ShippingStatuses,
    ShippingStatusHistory,
    PlacePicker,
    FixAddressesForm,
    ShippingCheckpoint,
    ShippingEtaBox
  },
  data() {
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      viewPhone: null,
      tracking: {},
      type: 'roadmap',
      size: [600, 300],
      config: this.$appConfig,
      apiKey: this.$appConfig.maps.api_key, // required
      zoom: 15, // required
      center: '',
      format: 'png',
      language: 'es',
      mapStyle: this.$appConfig.maps.staticMapStyle,
      markers: [],
      fitted: false,
      step: null,
      pickedupAt: '',
      deliveredAt: '',
      totalTime: null,
      theAddress: {
        to_place_id: null,
        to_extra: '',
        to_meta: ''
      },
      form: false,
      error: false,
      toAddress: '',
      visits: -1,
      validTo: false,
      limits: {
        to_meta: null
      },
      invalid: {},
      noiseRadius: 0.5, // Km
      unsubscribing: undefined,
      unsubscribed: false,
      isReverse: false
    }
  },
  computed: {
    isScheduled() {
      return this.shipping.scheduled_date && this.moment.utc(this.shipping.scheduled_date) > this.moment().utc()
    },
    isCloseToArrive() {
      return this.shipping.notifications_close_to_arrive &&
        this.shipping.notifications_close_to_arrive.length > 0 &&
        this.shipping.status_history[0].status === 'INTRANSIT' &&
        this.moment.utc(this.shipping.notifications_close_to_arrive[0].created_at) >= this.moment.utc(this.shipping.status_history[0].created_at).subtract(10, 'minutes')
    },
    ...mapGetters([
      'shipping',
      'currentUser',
      'comments'
    ])
  },
  watch: {
    isReverse(val) {
      this.init()
    }
  },
  mixins: [AddressMixins],
  mounted() {
    this.init()
  },
  beforeDestroy() {
    clearInterval(this.interval)
    this.moovaChatDestroyed = true
    if (window.MoovaChat) window.MoovaChat.destroy()
  },
  methods: {
    initMoovaChat() {
      // init() re-runs when isReverse flips; MoovaChat.init would remount the iframe.
      if (this.moovaChatStarted) return
      this.moovaChatStarted = true
      // Optional: without it the chat still works and asks for the recipient's phone or email to change the address.
      const hash = this.$route.query.hash
      const contact = (!this.isReverse ? this.shipping.to_contact : this.shipping.from_contact) || ''
      loadMoovaChat()
        .then(MoovaChat => {
          // The loader can resolve after the user already left the page.
          if (this.moovaChatDestroyed) return
          MoovaChat.init({
            surface: 'end-client',
            auth: { kind: 'guest', shippingId: String(this.shipping.id), ...(hash ? { hash } : {}) },
            user: { firstName: contact.trim().split(' ')[0] },
            context: { shippingId: String(this.shipping.id) }
          })
        })
        .catch(e => {
          this.moovaChatStarted = false
          console.log('Error', e)
        })
    },
    init() {
      if (this.$route.query.created) {
        this.showAlert()
        this.$router.push({ name: 'shipping', params: { id: this.$route.params.id } })
      }

      this.unsubscribing = this.$route.meta.unsubscribe

      const id = this.$route.params.id || this.$route.query.id
      if (id) {
        this.$store.dispatch(SHIPPING_RESET_STATE).then(() => {
          this.$store.dispatch(FETCH_SHIPPING_GUEST, { id, hash: this.$route.query.hash, reverse: this.isReverse })
            .then(() => {
              this.$frontConfig = this.shipping.address_to ? window.countries.find(x => x.iso_code === this.shipping.address_to.country).front_config : this.$frontConfig
              this.$frontConfig.i18n.tz = this.$tz = this.$cookies.get('bypassCountry') || !this.$frontConfig.i18n.tz ? 'UTC' : this.$frontConfig.i18n.tz
              this.theAddress.to_place_id = this.shipping.to_place_id
              this.theAddress.to_extra = this.shipping.to_extra
              this.theAddress.to_meta = this.shipping.to_meta
              this.limits.to_meta = 255 - (this.shipping.to_meta ? this.shipping.to_meta.length : 0)
              this.checkTracking()

              this.isReverse = this.shipping.shipping_type.name === 'reverse'

              if (this.shipping.status !== 'DELIVERED' && this.shipping.status !== 'CANCELED' && this.shipping.status !== 'RETURNED') {
                this.setInterval()
              }

              if (this.$eid === 1) {
                this.initMoovaChat()
              }
            }).catch((e) => {
              console.log('Error', e)
              this.error = true
            })
        })
      } else {
        this.form = true
      }
    },
    setUnsubscribe() {
      this.$http.post(this.$appConfig.api.baseUrl + 'guest/shippings/' + this.shipping.id + '/notifications/unsubscribe?hash=' + this.$route.query.hash)
        .then(() => {
          this.unsubscribed = true
        })
    },
    setInterval() {
      if (!this.unsubscribing) {
        this.interval = setInterval(function () {
          this.checkTracking()
        }.bind(this), 60000)
      } else {
        this.setUnsubscribe()
      }
    },
    clearInterval() {
      clearInterval(this.interval)
    },
    checkTracking() {
      const id = this.$route.params.id || this.$route.query.id
      switch (this.shipping.status) {
        case 'WAITING':
          this.step = 2
          break
        case 'CONFIRMED':
          this.step = 3
          break
        case 'INTRANSIT':
          this.step = 4
          break
        case 'DELIVERED':
          this.step = 5
          break
      }

      if (this.visits === 0) {
        for (let n = 0; n < this.shipping.status_history.length; n++) {
          if (
            (!this.isReverse && this.shipping.status_history[n].status === 'INCIDENCE' && this.shipping.status_history[n].details && this.shipping.status_history[n].details.reason === 'absent_recipient') ||
            (this.isReverse && this.shipping.status_history[n].status === 'INCIDENCE' && this.shipping.status_history[n].details && (this.shipping.status_history[n].details.reason === 'absent_client' || this.shipping.status_history[n].details.reason === 'unavailable_product'))
          ) {
            this.visits++
          }
        }
      }

      if (this.shipping.status !== 'DELIVERED' && this.shipping.status !== 'CANCELED') {
        this.$store.dispatch(FETCH_SHIPPING_GUEST, { id, hash: this.$route.query.hash, reverse: this.isReverse }).then((data) => {
          if ((!this.isReverse && !this.theAddress.to_place_id) || !this.theAddress.to_extra) {
            this.theAddress.to_place_id = this.shipping.to_place_id
            this.theAddress.to_extra = this.shipping.to_extra
            this.theAddress.to_meta = this.shipping.to_meta
          } else if ((this.isReverse && !this.theAddress.from_place_id) || !this.theAddress.from_extra) {
            this.theAddress.from_place_id = this.shipping.from_place_id
            this.theAddress.from_extra = this.shipping.from_extra
            this.theAddress.from_meta = this.shipping.from_meta
          }
          if (data.status === 'DELIVERED') {
            this.checkTracking()
            return true
          }

          if (this.shipping.status !== 'DRAFT' && this.shipping.status !== 'READY') {
            if ((!this.isScheduled || (
              this.shipping.status === 'PICKEDUP' ||
              this.shipping.status === 'INTRANSIT' ||
              this.shipping.status === 'INCIDENCE')) ||
              ((this.isReverse &&
                (this.shipping.status === 'CONFIRMED' ||
                this.shipping.status === 'ATPICKUPPOINT')
              ) &&
              this.shipping.courier)) {
              const noCourierYet = this.markers.length === 2 || false

              this.markers = []
              this.markers.push({
                id: '1',
                lat: this.isReverse && this.shipping.address_from ? this.shipping.address_from.lat : this.shipping.address_to.lat,
                lng: this.isReverse && this.shipping.address_from ? this.shipping.address_from.lng : this.shipping.address_to.lng,
                icon: !this.isReverse ? this.$appConfig.staticBaseUrl + 'static/img/ic_destination_on.svg' : this.$appConfig.staticBaseUrl + 'static/img/ic_origin_on.svg',
                x: 10,
                y: 10,
                infoText: !this.isReverse ? this.$gettext('Destination') : this.$gettext('Origin'),
                tooltip: true
              })

              if (data.current_tracking !== null) {
                if (noCourierYet) {
                  this.fitted = false
                }
                data.current_tracking = this.jitterize(parseFloat(data.current_tracking.lat), parseFloat(data.current_tracking.lng), this.noiseRadius)
                this.markers.push({
                  id: '2',
                  lat: data.current_tracking.lat,
                  lng: data.current_tracking.lng,
                  icon: {
                    type: 'marker-circle-fixed',
                    size: [this.noiseRadius * 1000, this.noiseRadius * 1000],
                    anchor: [25, 25]
                  },
                  x: 25,
                  y: 25,
                  infoText: this.courierI18n,
                  tooltip: true
                })
              }
            } else {
              this.markers = [
                {
                  id: '1',
                  lat: !this.isReverse ? this.shipping.address_to.lat : this.shipping.address_from.lat,
                  lng: !this.isReverse ? this.shipping.address_to.lng : this.shipping.address_from.lng,
                  icon: !this.isReverse ? this.$appConfig.staticBaseUrl + 'static/img/ic_destination_on.svg' : this.$appConfig.staticBaseUrl + 'static/img/ic_origin_on.svg',
                  x: 10,
                  y: 10,
                  infoText: !this.isReverse ? this.$gettext('Destination') : this.$gettext('Origin')
                }
              ]
            }
            if (this.$refs.fullMap) {
              this.$refs.fullMap.addMarkers(this.markers)
              if (this.fitted === false) {
                this.$refs.fullMap.fitted = false
                this.fitted = true
              }
            }
          }
        })
      } else {
        this.step = 5
        this.markers = [
          {
            label: 'B',
            color: 'green',
            icon: this.$appConfig.staticBaseUrl + 'static/img/ico-to_blue.png',
            lat: (!this.isReverse ? this.shipping.address_to.lat : this.shipping.address_from.lat) || null,
            lng: (!this.isReverse ? this.shipping.address_to.lng : this.shipping.address_from.lng) || null,
            size: 'normal'
          }
        ]
        for (let i = 0; i < this.shipping.status_history.length; i++) {
          if (this.shipping.status_history[i].status === 'INTRANSIT') {
            this.pickedupAt = this.shipping.status_history[i].created_at
          }
          if (this.shipping.status_history[i].status === 'DELIVERED') {
            this.deliveredAt = this.shipping.status_history[i].created_at
          }
        }
        const deliveredAtDate = new Date(Date.parse(this.deliveredAt.replace(/-/g, '/')))
        const pickedupAtDate = new Date(Date.parse(this.pickedupAt.replace(/-/g, '/')))
        const diffMs = (deliveredAtDate - pickedupAtDate)
        const diffDays = Math.floor(diffMs / 86400000)
        const diffHrs = Math.floor((diffMs % 86400000) / 3600000)
        const diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000)
        this.totalTime = (diffDays > 0 ? diffDays + 'd ' : '') + (diffHrs > 0 ? diffHrs + 'h ' : '') + (diffMins > 0 ? diffMins + 'm ' : '0m')
      }
    },
    countdown(value, limit) {
      this.limits[value] = this.theAddress[value] ? limit - this.theAddress[value].length : null
      this.invalid[value] = this.theAddress[value] ? this.theAddress[value].length <= limit : null
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  }
}
</script>

<style lang="scss">
#modalToPickPlace {
  .modal-content {
    padding: 20px;
    .modal-body {
      padding: 0;
    }
  }
}
.bg-info-light {
  background-color: #cef8ff !important;
}
</style>
